






































































































































































import Vue from "vue";
import i18n from "@/lang";

// Model
import moment from "moment";
import { formatCurrency } from "@/utility/Formatter";
import { InstallationTypeEnum, installationTypeEnumLabel } from "@/model/data/enums/InstallationTypeEnum";
import { GetBackOfficeTotalsByInstallationReqData } from "@/model/communication/branchReport/GetBackOfficeTotalsByInstallationReqData";
import { GetBackOfficeTotalsByInstallationResData } from "@/model/communication/branchReport/GetBackOfficeTotalsByInstallationResData";
import { GetBackOfficeTotalsByInstallationCommand } from "@/model/communication/branchReport/GetBackOfficeTotalsByInstallationCommand";

// Vue components
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import LocaleDateTimeTooltip from "@/components/LocaleDateTimeTooltip.vue";
import ColoredCurrencyTextField from "@/components/ColoredCurrencyTextField.vue";
import { RootState } from "@/store";

const HEADERS = () => [
    {
        enabled: true,
        text: i18n.t("branchReport.installationName"),
        value: "name",
        // class: "light-green lighten-5",
    },
    {
        enabled: true,
        text: i18n.t("common.tags"),
        value: "tags",
        // class: "light-green lighten-5",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.initialContent"),
        value: "initialContent",
        align: "end",
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.startingTime"),
        value: "firstTransactionTimestamp",
        align: "end",
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.finalContent"),
        value: "finalContent",
        align: "end",
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.endingTime"),
        value: "lastTransactionTimestamp",
        align: "end",
        isTextField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.cashIn"),
        value: "cashIn",
        align: "end",
        color: "light-green",
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.cashOut"),
        value: "cashOut",
        align: "end",
        color: "red",
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.balance"),
        value: "balance",
        align: "end",
        autoColor: true,
        isCurrencyField: true,
        class: "light-green lighten-4",
    },

    // Colonne solo per il front office
    {
        enabled: true,
        text: i18n.t("branchReport.paymentsExpectedAmount"),
        value: "paymentsExpectedAmount",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.paymentsAmount"),
        value: "paymentsAmount",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.notPaidChange"),
        value: "notPaidChange",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("common.withdrawals"),
        value: "withdrawal",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.totalFromBackOffice"),
        value: "totalFromBackOffice",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.banknotesFromBackOffice"),
        value: "banknotesFromBackOffice",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.coinsFromBackOffice"),
        value: "coinsFromBackOffice",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        class: "light-green lighten-4",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.totalToBackOffice"),
        value: "totalToBackOffice",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.banknotesToBackOffice"),
        value: "banknotesToBackOffice",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.coinsToBackOffice"),
        value: "coinsToBackOffice",
        align: "end",
        installationType: InstallationTypeEnum.FrontOffice,
        class: "light-green lighten-4",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.details"),
        value: "details",
        sortable: false,
        align: "center",
        installationType: InstallationTypeEnum.FrontOffice,
    },

    // Colonne solo per il back office
    {
        enabled: true,
        text: i18n.t("branchReport.cashiersBalance"),
        value: "cashiersBalance",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.refillsAmount"),
        value: "refillsAmount",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.depositedInBagAmount"),
        value: "depositedInBagAmount",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.emptyBagAmount"),
        value: "emptyBagAmount",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-3",
    },

    {
        enabled: true,
        text: i18n.t("branchReport.totalToFrontOffice"),
        value: "totalToFrontOffice",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.banknotesToFrontOffice"),
        value: "banknotesToFrontOffice",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.coinsToFrontOffice"),
        value: "coinsToFrontOffice",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
    {
        enabled: true,
        text: i18n.t("branchReport.totalFromFrontOffice"),
        value: "totalFromFrontOffice",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.banknotesFromFrontOffice"),
        value: "banknotesFromFrontOffice",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
    {
        enabled: false,
        text: i18n.t("branchReport.coinsFromFrontOffice"),
        value: "coinsFromFrontOffice",
        align: "end",
        installationType: InstallationTypeEnum.BackOffice,
        isCurrencyField: true,
        class: "light-green lighten-4",
    },
];

export default Vue.extend({
    components: {
        ColumnVisibilityFilter,
        LocaleDateTimeTooltip,
        ColoredCurrencyTextField,
    },
    data() {
        return {
            InstallationTypeEnum,
            backOfficeTotalsByInstallation: [],
            availableHeaders: [],
        };
    },
    props: ["items", "currentCurrency", "currentFilters", "detailsLoading"],
    computed: {
        tableHeaders() {
            let res = this.availableHeaders.filter((v) => v.enabled);

            if ((this.$store.state as RootState).authMod.currentUser.userConfig != null && (this.$store.state as RootState).authMod.currentUser.userConfig.theme == "dark")
                return res.map((c) => ({ ...c, class: "" }));
            else return res;
        },

        tableTitle() {
            return this.$t(installationTypeEnumLabel(this.items[0].installationType)) + " (" + this.currentCurrency + ")";
        },

        tableItems() {
            let res = [];
            this.items.forEach((item) => {
                let editedItem = { ...item };

                // front office
                editedItem.totalFromBackOffice = item.fromOtherOffice.banknoteCashValue + item.fromOtherOffice.coinCashValue;
                editedItem.banknotesFromBackOffice = item.fromOtherOffice.banknoteCashValue;
                editedItem.coinsFromBackOffice = item.fromOtherOffice.coinCashValue;

                editedItem.totalToBackOffice = item.toOtherOffice.banknoteCashValue + item.toOtherOffice.coinCashValue;
                editedItem.banknotesToBackOffice = item.toOtherOffice.banknoteCashValue;
                editedItem.coinsToBackOffice = item.toOtherOffice.coinCashValue;

                // back office
                editedItem.totalFromFrontOffice = item.fromOtherOffice.banknoteCashValue + item.fromOtherOffice.coinCashValue;
                editedItem.banknotesFromFrontOffice = item.fromOtherOffice.banknoteCashValue;
                editedItem.coinsFromFrontOffice = item.fromOtherOffice.coinCashValue;

                editedItem.totalToFrontOffice = item.toOtherOffice.banknoteCashValue + item.toOtherOffice.coinCashValue;
                editedItem.banknotesToFrontOffice = item.toOtherOffice.banknoteCashValue;
                editedItem.coinsToFrontOffice = item.toOtherOffice.coinCashValue;

                res.push(editedItem);
            });
            return res;
        },

        initialAvailableHeaders() {
            return HEADERS().filter((v) => v.installationType == null || v.installationType == this.items[0].installationType);
        },

        totals() {
            return {
                name: this.$t("common.totals"),
                initialContent: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.initialContent, 0)
                ),
                finalContent: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.finalContent, 0)
                ),
                cashIn: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.cashIn, 0)
                ),
                cashOut: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.cashOut, 0)
                ),
                balance: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.balance, 0)
                ),

                // Colonne per il front office
                paymentsExpectedAmount: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.paymentsExpectedAmount, 0)
                ),
                paymentsAmount: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.paymentsAmount, 0)
                ),
                notPaidChange: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.notPaidChange, 0)
                ),
                withdrawal: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.withdrawal, 0)
                ),
                totalFromBackOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.fromOtherOffice.banknoteCashValue + c.fromOtherOffice.coinCashValue, 0)
                ),
                banknotesFromBackOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.fromOtherOffice.banknoteCashValue, 0)
                ),
                coinsFromBackOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.fromOtherOffice.coinCashValue, 0)
                ),
                totalToBackOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.toOtherOffice.banknoteCashValue + c.toOtherOffice.coinCashValue, 0)
                ),
                banknotesToBackOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.toOtherOffice.banknoteCashValue, 0)
                ),
                coinsToBackOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.toOtherOffice.coinCashValue, 0)
                ),

                // Colonne per il back office
                cashiersBalance: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.cashiersBalance, 0)
                ),
                refillsAmount: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.refillsAmount, 0)
                ),
                emptyBagAmount: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.emptyBagAmount, 0)
                ),
                depositedInBagAmount: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.depositedInBagAmount, 0)
                ),
                totalToFrontOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.toOtherOffice.banknoteCashValue + c.toOtherOffice.coinCashValue, 0)
                ),
                banknotesToFrontOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.toOtherOffice.banknoteCashValue, 0)
                ),
                coinsToFrontOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.toOtherOffice.coinCashValue, 0)
                ),
                totalFromFrontOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.fromOtherOffice.banknoteCashValue + c.fromOtherOffice.coinCashValue, 0)
                ),
                banknotesFromFrontOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.fromOtherOffice.banknoteCashValue, 0)
                ),
                coinsFromFrontOffice: formatCurrency(
                    this.currentCurrency,
                    this.items.reduce((sum, c) => sum + c.fromOtherOffice.coinCashValue, 0)
                ),
            };
        },

        isComparisonLoaded() {
            if (this.items[0].installationType == InstallationTypeEnum.BackOffice) return true;
            else return this.items.length == this.backOfficeTotalsByInstallation.length;
        },
    },
    methods: {
        moment,
        formatCurrency,
        installationTypeEnumLabel,

        onDetailsClick(name: string) {
            console.log("InstallationName: ", name);
            this.$emit("details-event", name);
        },
        isLastMessageTooOld(lastMessage: string) {
            return moment().valueOf() - moment(lastMessage).valueOf() > 86400000;
        },
    },
    async mounted() {
        if (this.items[0].installationType == InstallationTypeEnum.FrontOffice) {
            await Promise.all(
                this.items.map(async (installation) => {
                    let reqData = new GetBackOfficeTotalsByInstallationReqData();
                    reqData.installationName = installation.name;
                    reqData.currency = this.currentCurrency;
                    reqData.startDate = this.currentFilters.startDate;
                    reqData.endDate = this.currentFilters.endDate;
                    let response: GetBackOfficeTotalsByInstallationResData = await new GetBackOfficeTotalsByInstallationCommand(reqData).execute();
                    this.backOfficeTotalsByInstallation.push({
                        installation: installation.name,

                        totalToFrontOffice: response.toOtherOffice.banknoteCashValue + response.toOtherOffice.coinCashValue,
                        banknotesToFrontOffice: response.toOtherOffice.banknoteCashValue,
                        coinsToFrontOffice: response.toOtherOffice.coinCashValue,

                        totalFromFrontOffice: response.fromOtherOffice.banknoteCashValue + response.fromOtherOffice.coinCashValue,
                        banknotesFromFrontOffice: response.fromOtherOffice.banknoteCashValue,
                        coinsFromFrontOffice: response.fromOtherOffice.coinCashValue,
                    });
                })
            );
        }
    },
});
